<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <!--<vx-card class="list-view-item overflow-hidden" v-on="$listeners">

    <template slot="no-body">
      <div class="vx-row item-details no-gutter">

        &lt;!&ndash; IMG COL &ndash;&gt;
        <div @click="navigateToEditCourse"
             class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center cursor-pointer">
          <img class="grid-view-img p-4"
               :src="classRoomPictureCompute"
               alt="content-img">
        </div>

        &lt;!&ndash; ITEM NAME & DESC COL &ndash;&gt;
        <div class="vx-col sm:w-1/2">
          <div class="p-4 pt-6">
            <slot name="item-meta">
              <h6 @click="navigateToEditCourse"
                  class="item-name font-semibold mb-1 hover:text-primary cursor-pointer">{{ item.subject.code }}</h6>
              <span class="font-semibold cursor-pointer">{{ item.subject.nameLocal }}</span>
              <p class="item-description text-sm">{{ $t('student-enroll.section-no') }} {{ item.sectionNo }}</p>
              <p class="item-description text-sm">{{ $t('student-enroll.learn-span-no') }} {{ getClassSection(item) }}</p>

            </slot>
          </div>
        </div>

        &lt;!&ndash; PURCHASE COL &ndash;&gt;
        <div
          class="vx-col sm:w-1/4 w-full flex items-center sm:border border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

          <div class="p-4 flex flex-col w-full">

            <div class="text-warning flex self-end border border-solid border-warning py-1 px-2 rounded">
              <span class="text-sm mr-1">{{ item.studentRegisterQty }}/{{ item.capacity }}</span>
              <feather-icon icon="PersonIcon" svgClasses="h-4 w-4"/>

              &lt;!&ndash;<vs-chip color="primary cursor-pointer" transparent>
                {{ item.studentRegisterQty}}/{{ item.capacity }}
              </vs-chip>&ndash;&gt;
            </div>

            &lt;!&ndash;ACTION BUTTONS &ndash;&gt;

            <div class="p-3 flex flex-grow items-center justify-center mb-0">
              <vs-button class="w-full" color="success" type="gradient" icon-pack="feather" icon="icon-book">
                {{ $t('teacher-dash-board.home-work') }}
              </vs-button>
            </div>
            <div class="p-3 flex flex-grow items-center justify-center">
              <vs-button class="w-full" color="warning" type="gradient" icon-pack="feather" icon="icon-upload">
                {{ $t('teacher-dash-board.submit-score') }}
              </vs-button>
            </div>
            <div class="p-3 flex flex-grow items-center justify-center">
              <vs-button class="w-full" color="danger" type="gradient" icon-pack="feather" icon="icon-bar-chart-2">
                {{ $t('teacher-dash-board.student-stat') }}
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </template>

  </vx-card>-->

  <vx-card>

    <vs-table-mod :data="items"
                  :max-items="tableConfig.maxItemsPerPage"
                  pagination
                  search
    >

      <template slot="thead"
                v-for="(thead, indexth) in table.header"
      >
        <vs-th :key="indexth" :sort-key="thead.id" :width="thead.width">
          {{ $t(thead.title) }}
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr
          :data="{ data: tr, index: indextr }"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td width="40">
            {{ indextr + 1 }}
          </vs-td>
          <vs-td>
            {{ tr.subject.code }}
          </vs-td>
          <vs-td>
            {{ tr.subject.nameLocal }}
          </vs-td>
          <vs-td>
            {{ tr.sectionNo }}
          </vs-td>
          <vs-td>
            {{ tr.classSection ? tr.classSection.learnSpanNo:'-' }}
          </vs-td>
          <vs-td>
            {{ tr.studentRegisterQty }}/{{ tr.capacity }}
          </vs-td>

          <vs-td class="whitespace-no-wrap" width="100">
            <feather-icon @click="navigateToEditCourse(tr)" icon="EditIcon"
                          class="mr-2"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
            <feather-icon @click="navigateToHomeWork(tr)" icon="BookIcon"
                          class="mr-2 text-success"
                          svgClasses="w-5 h-5 text-success hover:text-primary stroke-current"/>

            <feather-icon @click="navigateToSubmitScore(tr)" icon="UploadIcon"
                          class="mr-2"
                          svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current"/>

            <feather-icon @click="navigateToStudentStat(tr)" icon="BarChart2Icon"
                          class="mr-2"
                          svgClasses="w-5 h-5 text-danger hover:text-primary stroke-current"/>

            <other-menu-drop-down :item="tr"></other-menu-drop-down>

          </vs-td>

        </vs-tr>
      </template>
    </vs-table-mod>

  </vx-card>

</template>

<script>
  import {tableConfig} from '@/utils/table'
  import vsTableMod from '@/components/vuesax-mod/components/vsTable/vsTable.vue';
  import OtherMenuDropDown from "./DropDownMenu/OtherMenuDropDown";

  export default {
    props: {
      items: {
        type: Array,
        required: true
      }
    },
    components: {
      vsTableMod,
      OtherMenuDropDown,
    },
    data(){
      return {
        table: {
          header: [
            {title: 'live-class-schedule.no', id: 'no'},
            {title: 'live-class-schedule.subject-code', id: 'subjectCode'},
            {title: 'live-class-schedule.subject-name', id: 'subjectName'},
            {title: 'live-class-schedule.section', id: 'classSectionQty'},
            {title: 'class-section.learn-span-no', id: 'learnSpanNo'},
            {title: 'student-enroll.student-qty', id: 'studentQty'},
            {title: 'general.manage', id: '', width: 100},
          ]
        },
        tableConfig: tableConfig,

      }
    },
    computed: {
    },
    methods: {
      //---------------------------------------- Event Function ------------------------------------------------------//
      navigateToEditCourse(tr) {
        this.$router.push({
          name: 'class-over-view',
          params: {
            classRoomId: tr.id
          }
        })
          .catch(() => {
          })
      },
      navigateToHomeWork(tr) {
        this.$router.push({
          name: 'student-assignment',
          params: {
            classSectionId: tr.classSection.id
          }
        })
          .catch(() => {
          })
      },
      navigateToSubmitScore(tr) {
        this.$router.push({
          name: 'student-score',
          params: {
            classSectionId: tr.classSection.id
          }
        })
          .catch(() => {
          })
      },
      navigateToStudentStat(tr) {
        this.$router.push({
          name: 'student-stats',
          params: {
            classSectionId: tr.classSection.id
          }
        })
          .catch(() => {
          })
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
    }
  }
</script>

<style lang="scss" scoped>
  /*.list-view-item {
    .item-name, .item-description {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .item-name {
      -webkit-line-clamp: 2;
    }

    .item-description {
      -webkit-line-clamp: 5;
    }

    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

      .grid-view-img {
        opacity: 0.9;
      }
    }
  }*/
</style>
